export const userToken = (state) => state.authToken;
export const pdv = (state) => state.pdv;
export const loggedUser = (state) => state.loggedUser;
export const loginPosData = (state) => state.loginPosData;
export const eventId = (state) => state.eventId;
export const widgetMode = (state) => state.widgetMode;
export const step = (state) => state.step;
